<script setup lang="ts">
defineOptions({
  name: 'BlogOverview',
});

const classNameRef = ref(['']);
const { getLocalePathByPage } = useMopRouter();
const { initTransition } = useMopPageTransitionClient();

const { storyListRef, totalPagesRef, loadingRef } = await useMopCmsStoryListPage({
  cacheKeyPrefix: 'blog-overview',
  slug: '/career/career-blog',
  pageType: 'Blog',
});

initTransition(classNameRef, loadingRef);
</script>

<template>
  <div :class="['blog-overview-page', 'transition', ...classNameRef]">
    <MopPageLoad :class="classNameRef" />
    <div class="transition-content">
      <template v-if="storyListRef">
        <MopBlogNewsItem v-for="story in storyListRef" :key="story.getUuId()" :story="story" />
        <UiPagination
          v-if="totalPagesRef > 1"
          :key="`blog-${totalPagesRef}-${$route.query.fullPath}-${$route.query.page}`"
          :page="$route.query.page?.toString()"
          :total-pages="totalPagesRef"
          class="blog-overview__pagination"
          :get-locale-path-by-page="getLocalePathByPage"
        />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.blog-overview__pagination {
  margin-top: $space30;
}
</style>
